import { applyFilter, applySearchFilter } from '../../Utils/Utils';

export const applyFilters = ({ list, filters }) => {
  let filteredList = list;
  // filter on status
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'status',
    defaultFilter: ['submitted', 'pending', 'project'],
  });
  // filter on commercialProductName
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'commercialProductName',
    defaultFilter: [],
  });
  // filter on commercialProductId
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'commercialProductId',
    defaultFilter: [],
  });
  // query filter on field: partyName, id
  filteredList = applySearchFilter({
    list: filteredList,
    filters,
    rowNames: ['partyName', 'id'],
  });

  return filteredList;
};

export const defaultFiltersProps = {
  query: '',
  status: ['submitted', 'project', 'pending'],
  commercialProductId: [],
};
